// GENERATED by scripts/write-local-env.js from .env — do not edit, do not commit.
// Only the development build reads these; staging/prod set api.host outright.
export const LOCAL_API_PORT = 8088;
export const LOCAL_CLIENT_PORT = 3000;
